import { createDispatchFunction } from 'shared/helpers';
import partial from 'lodash/partial';
import { TestCenterDTO } from 'shared/models';
import DashboardService from './DashboardService';

// Actions
const GET_USER_ASSIGNMENTS = 'userDashboard/GET_USER_ASSIGNMENTS';
const GET_USER_TEST_CENTERS = 'userDashboard/GET_USER_TEST_CENTERS';
const GET_AVAILABLE_TERMS = 'userDashboard/GET_AVAILABLE_TERMS';
const ACCEPT_TERMS = 'userDashboard/ACCEPT_TERMS';

const initialState = {
  assignments: [],
  testCenters: [],
  terms: [],
  acceptedTerm: {},
  termsLoading: false,
};

// Reducer
export default function dashboardReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_USER_ASSIGNMENTS:
      return {
        ...state,
        assignments: action.result.data || [],
        assignmentsLoading: action.result.loading || false,
      };
    case GET_USER_TEST_CENTERS: {
      if (action.result.data) {
        return {
          ...state,
          testCenters: action.result.data.map(tc => new TestCenterDTO(tc)),
        };
      }
      return {
        ...state,
        testCenters: [],
      };
    }
    case GET_AVAILABLE_TERMS:
      return {
        ...state,
        terms: action.result.data || [],
        termsLoading: action.result.loading || false,
      };
    case ACCEPT_TERMS:
      return {
        ...state,
        acceptedTerm: action.result.data || {},
      };
    default:
      return state;
  }
}

// Action Creators
export function getUserAssignmentsAction(result) {
  return { type: GET_USER_ASSIGNMENTS, result };
}

export function clearUserAssignmentsAction() {
  return { type: GET_USER_ASSIGNMENTS, result: { data: [], loading: false } };
}

export function getUserTestCentersAction(result) {
  return { type: GET_USER_TEST_CENTERS, result };
}

export function getAvailableTermsAction(result) {
  return { type: GET_AVAILABLE_TERMS, result };
}

export function acceptTermsAction(result) {
  return { type: ACCEPT_TERMS, result };
}

// Action dispatcher functions

export function getUserAssignments(userId) {
  return createDispatchFunction(
    partial(DashboardService.getUserAssignments, userId),
    getUserAssignmentsAction
  );
}

export function getUserTestCenters(userId) {
  return createDispatchFunction(
    partial(DashboardService.getUserTestCenters, userId),
    getUserTestCentersAction
  );
}

export function getAvailableTerms(userId, status) {
  return createDispatchFunction(
    partial(DashboardService.getAvailableTerms, userId, status),
    getAvailableTermsAction,
  );
}

export function acceptTerms(userId, termId) {
  return createDispatchFunction(
    partial(DashboardService.acceptTerms, userId, termId),
    acceptTermsAction,
  );
}
